import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
export default {
  name: "pro-chiose-tabs",
  props: {
    value: {
      type: String,
      default() {
        return false;
      }
    },
    tabs: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      tabData: [{
        // lg: 部门
        name: $t("pgxs2", "部门"),
        value: "departmemt"
      }, {
        // lg: 成员
        name: $t("h5542", "成员"),
        value: "member"
      }, {
        // lg: 组织架构
        name: $t("gio3m94", "组织架构"),
        value: "structure"
      }, {
        // lg: 岗位
        name: $t("g6mu2", "岗位"),
        value: "position"
      }, {
        // lg: 应用
        name: $t("gqac2", "应用"),
        value: "apps"
      }]
    };
  },
  computed: {
    _tabData() {
      return this.tabData.filter(v => this.tabs.includes(v.value));
    }
  },
  methods: {
    onChange(item) {
      if (item.value !== this.value) {
        this.$emit("input", item.value);
      }
    }
  }
};